
export const FETCH_PROFILE_REQUESTED: string = 'USER/FETCH_PROFILE_REQUESTED'
export const FETCH_PROFILE_SUCCESS: string = 'USER/FETCH_PROFILE_SUCCESS'
export const FETCH_PROFILE_FAILED: string = 'USER/FETCH_PROFILE_FAILED'

export const LOGIN_REQUESTED: string = 'USER/LOGIN_REQUESTED'
export const LOGIN_SUCCESS: string = 'USER/LOGIN_SUCCESS'
export const LOGIN_FAILED: string = 'USER/LOGIN_FAILED'

export const IS_LOGIN_REQUESTED: string = 'USER/IS_LOGIN_REQUESTED'
export const IS_LOGIN_SUCCESS: string = 'USER/IS_LOGIN_SUCCESS'
export const IS_LOGIN_FAILED: string = 'USER/IS_LOGIN_FAILED'

export const LOGOUT_REQUESTED: string = 'USER/LOGOUT_REQUESTED'
export const LOGOUT_SUCCESS: string = 'USER/LOGOUT_SUCCESS'
export const LOGOUT_FAILED: string = 'USER/LOGOUT_FAILED'
